import type { Shipment } from '../../types/dto';

const inactive = new Set(['cancelled', 'failed', 'error', 'draft']);

export function normalizeShipmentStatus(value: unknown): string {
  const status = String(value || '').trim().toLowerCase();
  return ({ ready_to_pickup: 'ready_for_pickup', label_created: 'label_generated', shipped: 'dispatched' } as Record<string, string>)[status] || status || 'no_shipment';
}

/** Same policy as shipment_denorm: latest live parcel; cancelled retries do not win. */
export function shipmentStatusFromRows(rows: Shipment[]): string {
  const live = rows.filter(row => row.status && !inactive.has(normalizeShipmentStatus(row.status)));
  live.sort((a, b) => {
    const date = (row: Shipment) => Date.parse(row.created_at || '') || 0;
    return date(b) - date(a) || Number(b.id || 0) - Number(a.id || 0);
  });
  return live.length ? normalizeShipmentStatus(live[0].status) : 'no_shipment';
}

/** Patch only this order, keeping scroll position, selection and the open drawer. */
export function applyShipmentStatus(order: any, rows: Shipment[], renderBadge: (order: any) => string): void {
  const status = shipmentStatusFromRows(rows);
  // An empty response has no new carrier evidence (external tracking may be on the order).
  const previouslyLoaded = Number(order._loadedShipmentCount || 0);
  order._loadedShipmentCount = rows.length;
  if (!rows.length && !previouslyLoaded) return;
  const changed = normalizeShipmentStatus(order.shipment_status) !== status;
  order.shipment_status = status;
  const w = window as any;
  const upsert = w.__sbExports?.upsertOrderInStore || w.upsertOrderInStore;
  if (typeof upsert === 'function') upsert(order);
  document.querySelectorAll<HTMLElement>('[data-shipment-order-id]').forEach(badge => {
    if (badge.dataset.shipmentOrderId === String(order.id)) badge.outerHTML = renderBadge(order);
  });
  if (changed && typeof w._invalidateOrdersPageCache === 'function') w._invalidateOrdersPageCache();
}
